import React from 'react';

import {
  ContentBox,
  ContentContainer,
} from '@/shared/components/layouts/content-layout/content-layout.styled';
import { TContentLayoutProps } from '@/shared/components/layouts/content-layout/content-layout.types';
import { Head } from '@/shared/components/seo';

export const ContentLayout: React.FC<TContentLayoutProps> = ({
  children,
  title,
  fullWidth,
}) => {
  return (
    <>
      <Head title={title} />
      <ContentContainer>
        <ContentBox $fullWidth={fullWidth}>{children}</ContentBox>
      </ContentContainer>
    </>
  );
};
